/* AVENOR Fit — lightweight, framework-free and compatible with Shopify theme app blocks. */
(function () {
  'use strict';
  const SELECTOR = '[data-avenor-fit]';
  const SIZES = ['S', 'M', 'L', 'XL', 'XXL'];
  function parseCentimeters(value) {
    if (typeof value === 'number') return Number.isFinite(value) && value > 0 ? value : null;
    if (typeof value !== 'string') return null;
    const normalized = value.trim().replace(',', '.');
    if (!/^\d+(?:\.\d+)?$/.test(normalized)) return null;
    const cm = Number(normalized);
    return Number.isFinite(cm) && cm > 0 ? cm : null;
  }
  function cmToInches(value) {
    const cm = parseCentimeters(value);
    return cm == null ? null : (Math.round((cm / 2.54) * 10) / 10).toFixed(1);
  }
  function rootsIn(scope) {
    const roots = [];
    if (scope && scope.matches?.(SELECTOR)) roots.push(scope);
    scope?.querySelectorAll?.(SELECTOR).forEach(el => roots.push(el));
    return roots;
  }
  function init(scope) {
    rootsIn(scope || document).forEach(el => {
      if (el.dataset.afInitialized === 'true') return;
      const opener = el.querySelector('[data-af-open]');
      const dialog = el.querySelector('[data-af-dialog]');
      if (!opener || !dialog || typeof dialog.showModal !== 'function') return;
      el.dataset.afInitialized = 'true';
      function close() { if (dialog.open) dialog.close(); }
      function open() { if (!dialog.open) dialog.showModal(); }
      opener.addEventListener('click', open);
      el.querySelectorAll('[data-af-close]').forEach(btn => btn.addEventListener('click', close));
      dialog.addEventListener('click', e => {
        // Only clicks outside the panel dismiss the modal; content clicks never do.
        if (e.target === dialog) close();
      });
      dialog.addEventListener('close', () => { if (opener.isConnected) opener.focus({preventScroll:true}); });
      function showUnit(unit) {
        if (!['cm', 'in'].includes(unit)) return;
        el.dataset.afActiveUnit = unit;
        el.querySelectorAll('[data-af-measurement]').forEach(cell => {
          const source = cell.getAttribute('data-cm');
          cell.textContent = unit === 'in' ? cmToInches(source) ?? '—' : source;
        });
        el.querySelectorAll('[data-af-unit]').forEach(btn => {
          btn.setAttribute('aria-pressed', String(btn.dataset.afUnit === unit));
        });
        const caption = el.querySelector('[data-af-unit-caption]');
        if (caption) caption.textContent = unit === 'in' ? '(in)' : '(cm)';
        const description = el.querySelector('[data-af-unit-description]');
        if (description) description.textContent = unit === 'in' ? 'inches' : 'centimeters';
      }
      el.querySelectorAll('[data-af-unit]').forEach(btn => btn.addEventListener('click', () => showUnit(btn.dataset.afUnit)));
      function selectSize(size) {
        if (size && !SIZES.includes(size)) return;
        el.dataset.afSelectedSize = size || '';
        el.querySelectorAll('[data-af-size]').forEach(btn => {
          btn.setAttribute('aria-pressed', String(btn.dataset.afSize === size));
        });
        el.querySelectorAll('[data-af-size-col]').forEach(cell => {
          cell.classList.toggle('af-selected-col', cell.dataset.afSizeCol === size);
        });
        const clear = el.querySelector('[data-af-size-clear]');
        if (clear) clear.hidden = !size;
      }
      el.querySelectorAll('[data-af-size]').forEach(btn => btn.addEventListener('click', () => selectSize(btn.dataset.afSize)));
      el.querySelector('[data-af-size-clear]')?.addEventListener('click', () => selectSize(null));
    });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { parseCentimeters, cmToInches, rootsIn, SIZES, init };
  if (typeof document !== 'undefined') {
    const boot = () => init(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', e => init(e.target));
    document.addEventListener('shopify:block:select', e => init(e.target));
    document.addEventListener('shopify:section:reorder', e => init(e.target));
    // Shopify's mini PDP inserts the product section asynchronously; inline
    // <script> elements in fetched markup are not guaranteed to execute.
    // Watch for newly inserted app roots, without reinitializing old roots.
    const observeNewRoots = () => {
      if (!document.body || typeof MutationObserver === 'undefined') return;
      const observer = new MutationObserver(records => {
        for (const record of records) {
          for (const node of record.addedNodes) {
            if (node.nodeType !== 1) continue;
            if (node.matches?.(SELECTOR) || node.querySelector?.(SELECTOR)) init(node);
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeNewRoots);
    else observeNewRoots();
  }
})();
